import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './theme/tokens.css';
import './theme/toast.css';
import './components/header/IconButton.css';
import './components/designSystem/DrawerMutedFields.dark.css';
import './components/subComponents/buttons/FormFooterDark.css';
import './components/main/AddContentWrapper.dark.css';
import './components/gMap/Gmap.css';
import './components/DesignationLevel/DynamicModal.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './store'
import {Provider} from 'react-redux'
// import { messaging } from './firebase';
if (localStorage.getItem("theme") === "dark") {
  document.documentElement.setAttribute("data-theme", "dark");
}   
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
  
);
if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/firebase-messaging-sw.js', { scope: '/' })  
    .then((registration) => {
      console.log('Service Worker registered with scope:', registration.scope);

    })
    .catch((error) => {
      console.error('Service Worker registration failed:', error);
    });
}


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
